import {Component, ElementRef, Inject, Input, Renderer2} from '@angular/core';
import {Plugins} from '@capacitor/core';
import {DOCUMENT} from "@angular/common";
import {MapStyle} from './map-style';
import LatLng = google.maps.LatLng;
import MarkerOptions = google.maps.MarkerOptions;
import {Events, NavController, NavParams} from "ionic-angular";
import {DiscoveryFeedMapPage} from "../../pages/discovery-feed-map/discovery-feed-map";
import {ShopPage} from "../../pages/shop/shop";
import {HttpClient} from "@angular/common/http";
import {latLng, LocationServiceProvider} from "../../providers/location-service/location-service";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {DurationPipe} from "../../pipes/duration/duration";

const {Network} = Plugins;

@Component({
    selector: 'google-maps',
    templateUrl: 'google-maps.html'
})
export class GoogleMapsComponent {

    @Input('apiKey') apiKey: string;
    @Input('shops') shops: any;
    @Input('position') position: any;
    @Input('latLng') latLng: any;
    @Input('static') static: boolean;
    @Input('hasOverlay') hasOverlay: boolean;
    @Input('showInfoWindow') showInfoWindow: boolean;
    @Input('showMapCentrePoint') showMapCentrePoint: boolean = false;
    @Input('updateShopsOnMove') updateShopsOnMove;
    // @Input('shopType') shopType: 0 | 1; //0 - barber shop, 1 - coffe shop

    public errors: {};
    public map: any;
    public markers: any[] = [];
    private mapsLoaded: boolean;
    private networkHandler = null;
    private shop: any;
    private infoWindow: object;
    private activeMarker: any;
    private markerClick: boolean;
    public loading: boolean;

    public fromAbout: boolean = false;

    constructor(private renderer: Renderer2, private element: ElementRef, @Inject(DOCUMENT) private _document, public navParams: NavParams, public navCtrl: NavController, public events: Events, public http: HttpClient, public locationService: LocationServiceProvider, private apiErrorHandler: ApiErrorHandlerProvider, public durationPipe: DurationPipe) {
        this.apiKey = 'AIzaSyBn0ar8Xk7fGbOFiqDreEKWajNvrZglAG4';
        this.shop = this.navParams.get('shop');
        this.shops = this.navParams.get('shops');
        this.latLng = this.navParams.get('latLng');
        this.fromAbout = this.navParams.get('fromAbout');
        // this.shopType = this.navParams.get('shopType');
        this.markerClick = false;
        this.mapsLoaded = false;
        this.static = false;
        this.hasOverlay = false;
        this.showInfoWindow = false;

    }

    ngOnInit() {

      if (this.updateShopsOnMove === undefined){
        this.updateShopsOnMove = true; // Default value
      }

      this.initMap().then((res) => {
      });

    }

    private init(): Promise<any> {

        return new Promise((resolve, reject) => {

            this.loadSDK().then((res) => {

                this.initMap().then((res) => {
                    resolve(true);
                }, (err) => {
                    reject(err);
                });

            }, (err) => {

                reject(err);

            });

        });

    }

    private loadSDK(): Promise<any> {

        console.log("Loading Google Maps SDK");

        return new Promise((resolve, reject) => {

            if (!this.mapsLoaded) {

                Network.getStatus().then((status) => {

                    if (status.connected) {

                        this.injectSDK().then((res) => {
                            resolve(true);
                        }, (err) => {
                            reject(err);
                        });

                    } else {

                        if (this.networkHandler == null) {

                            this.networkHandler = Network.addListener('networkStatusChange', (status) => {

                                if (status.connected) {

                                    this.networkHandler.remove();

                                    this.init().then((res) => {
                                        console.log("Google Maps ready.")
                                    }, (err) => {
                                        console.log(err);
                                    });

                                }

                            });

                        }

                        reject('Not online');
                    }

                }, (err) => {

                    // NOTE: navigator.onLine temporarily required until Network plugin has web implementation
                    if (navigator.onLine) {

                        this.injectSDK().then((res) => {
                            resolve(true);
                        }, (err) => {
                            reject(err);
                        });

                    } else {
                        reject('Not online');
                    }

                });

            } else {
                reject('SDK already loaded');
            }

        });


    }

    private injectSDK(): Promise<any> {

        return new Promise((resolve, reject) => {

            window['mapInit'] = () => {
                this.mapsLoaded = true;
                resolve(true);
            };

            let script = this.renderer.createElement('script');
            script.id = 'map_canvas';

            if (this.apiKey) {
                script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.apiKey + '&callback=mapInit';
            } else {
                script.src = 'https://maps.googleapis.com/maps/api/js?callback=mapInit';
            }

            if (!this._document.getElementById('map_canvas')) {
                this.renderer.appendChild(this._document.body, script);
            }
        });

    }

    /**
     * Initialise the map with specific settings for the 'static' map and main map page
     *
     */
    private initMap(): Promise<any> {
        return new Promise((resolve, reject) => {

            if (!this.latLng) reject('Could not initialise map');

            let lat = Object.keys(this.latLng).length === 0 ? 0 : this.latLng.lat;
            let lng = Object.keys(this.latLng).length === 0 ? 0 : this.latLng.lng;

            let latLng = new google.maps.LatLng(lat, lng);
            let zoom = Object.keys(this.latLng).length === 0 ? 1 : 14;

            let mapOptions: any = {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                center: latLng,
                zoom: zoom,
                styles: MapStyle,
                disableDefaultUI: true,
            };

            if (this.static || this.fromAbout) {
                mapOptions.gestureHandling = 'none';
                mapOptions.zoomControl = false;
                mapOptions.scrollwheel = false;
                mapOptions.scaleControl = false;
                mapOptions.draggable = false;
                mapOptions.navigationControl = false;
            }

            // Create the map
            this.map = new google.maps.Map(this.element.nativeElement.children[0], mapOptions);

            // Add the shop markers
            this.addMarkers(this.shops, this.map);

            if (!this.static) {
                if (Object.keys(this.latLng).length !== 0 && !this.fromAbout) {
                    this.addYourLocationButton();
                }

                if (this.updateShopsOnMove) {
                  this.map.addListener('idle', () => {

                    if (!this.markerClick) {
                      // Get the shops
                      this.getShops(this.map.getCenter().lat(), this.map.getCenter().lng());

                      // Reset the marker click to default state
                      this.markerClick = false;
                    }
                  });

                  // As soon as the user begins to move on the map we will clear the markers
                  // to make the map feel more responsive
                  this.map.addListener('dragstart', () => {
                    this.deleteMarkers();
                  });
                }

            }

            // Center the map to the static map marker
            // Or center it to the current location of the user
            if (this.static) {
                this.map.setCenter(this.shops[0].latLng);
            } else {
                if (this.shop && this.shop.latLng) {
                    this.map.setCenter(this.shop.latLng);
                } else {
                    this.map.setCenter(latLng); 
                }
            }

            resolve(true);
        });
    }

    /**
     * Loop through the shop data and add all the makers
     *
     * @param shops
     * @param map
     */
    public addMarkers(shops: Array<object>, map): void {
        if (!shops) return;

        let $this = this;
        shops.forEach((shop: any) => {
            // @ts-ignore
            // console.log(this.shopType, shop);
            // if (shop.settings && shop.settings.shop_type === this.shopType) {
            let options: any = {
                map: map,
                icon: $this.createIcon(),
                position: shop.latLng,
                visible: true,
                // @ts-ignore
                shop: shop
            };

            $this.addMarker(options, shop);
            // }
        });
    }



    /**
     * Add a single marker and call the method to toggle the info window on
     * click event on the marker. Also listens for click even on the map
     * to reset the markers
     *
     * @param options
     * @param shop
     */
    public addMarker(options: MarkerOptions, shop: any): void {
        let marker = new google.maps.Marker(options);
        this.markers.push(marker);
        let $this = this;

        // Add the Info window on page load
        // Open the infowindow on page load if there is a shop passed to the component
        //@todo check the id (or other unique value) rather than name during the match

        if (!this.static && $this.shop !== undefined && $this.shop.name === shop.name) {
          console.log('static');
          console.log(this.static);
          console.log($this.shop);
          console.log($this.shop.name);
          console.log(shop.name);
            // Prevent the idle event in initMap() from running into a loop of fetching and redrawing the markers
            this.markerClick = true;
            $this.infoWindow = shop;
            this.toggleInfoWindow(marker);
            this.activeMarker = marker;
            this.map.setCenter(shop.latLng);
        }

        // Listen to click events on the marker and update the info window
        google.maps.event.addListener(marker, 'click', () => {
            // Reset all shop markers if non shop marker is clicked
            // @ts-ignore
            if (!marker.shop) {
                $this.resetMarkers();
            }

            // Prevent the idle event in initMap() from running into a loop of fetching and redrawing the markers
            this.markerClick = true;

            $this.toggleInfoWindow(marker);
        });

        // Reset all shop markers if no marker is clicked on the map
        this.map.addListener("click", () => {
            // close infoWindow
            $this.infoWindow = {};
            this.activeMarker = false;
            $this.resetMarkers();

            // Set the marker click to false so that when the map 'idle' event fires; it will be able to request for shops
            this.markerClick = false;
        });
    }

    /**
     * Reset all the shop markers
     */
    private resetMarkers(): void {
        let $this = this;

        $this.markers.forEach(marker => {
            // Only change the icons of the shop markers
            if (marker.shop) {
                marker.setIcon(this.createIcon())
            }
        });
    }

    /**
     * Show or hide the custom info window over the map
     *
     * @param marker
     */
    private toggleInfoWindow(marker): void {
        let $this = this;

        if (!this.activeMarker || this.activeMarker.shop.latLng !== marker.shop.latLng) {

            $this.resetMarkers();
            $this.infoWindow = marker.shop;
            this.activeMarker = marker;

            if (marker.shop) {
                marker.setIcon(this.createIcon('active-marker'))
            }

            $this.map.setCenter(marker.latLng);
            $this.map.panBy(0, 80);

            return;
        }

        if (this.activeMarker.shop.latLng === marker.shop.latLng) {
            $this.infoWindow = {};
            this.activeMarker = false;

            if (marker.shop) {
                marker.setIcon(this.createIcon())
            }

            $this.map.setCenter(marker.latLng);
            $this.map.panBy(0, 0);

            return;
        }
    }

    /**
     * Create a google map marker icon
     *
     * @param $type
     * @param width
     * @param height
     */
    private createIcon($type: string = 'default-marker', width: number = 40, height: number = 45): {} {

        let icon = {
            url: "./assets/icon/map-pin-teal.svg",
            scaledSize: new google.maps.Size(width, height)
        };

        if ($type === 'active-marker') {
            icon.url = "./assets/icon/map-pin-purple.svg";
        }

        if ($type === 'current-location') {
            icon.url = "./assets/icon/location-current.svg";
        }

        return icon;
    }

    private addYourLocationButton(): void {

        this.locationService.geolocate().then((latLng: latLng) => {
            let location = new google.maps.LatLng(latLng.lat, latLng.lng);
            // Create a div on the map to hold the button that calls on a method
            // to center the user's map in their current location
            let centerControlDiv = document.createElement('div');
            new this.centerControl(centerControlDiv, this.map, location, this);
            centerControlDiv.tabIndex = 1;
            this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(centerControlDiv);
        });
    }

    /**
     * The centerControl adds a control to the map that recenters the map on a location
     * This constructor takes the control DIV as an argument.
     * @constructor
     * @ref https://developers.google.com/maps/documentation/javascript/examples/control-custom
     */
    private centerControl(controlDiv: HTMLDivElement, map, location: LatLng, component:GoogleMapsComponent): void {

        // Set CSS for the control border.
        let controlUI = document.createElement('button');
        controlUI.style.backgroundColor = '#fff';
        controlUI.style.backgroundImage = 'url("./../assets/icon/location.svg")';
        controlUI.style.backgroundSize = '14px';
        controlUI.style.backgroundRepeat = 'no-repeat';
        controlUI.style.backgroundPositionX = 'center';
        controlUI.style.backgroundPositionY = 'center';
        controlUI.style.margin = '16px 16px 0 0';
        controlUI.style.height = '30px';
        controlUI.style.width = '30px';
        controlUI.style.borderRadius = '6px';
        controlUI.style.boxShadow = '0px 0px 4px rgba(0, 0, 0, 0.08);';
        controlUI.title = 'Click to recenter the map';
        controlDiv.appendChild(controlUI);

        // Setup the click event listeners: simply set the map to Chicago.
        controlUI.addEventListener('click', () => {
            map.setCenter(location);
            map.panBy(0, 0);
            if (component.updateShopsOnMove) {
              component.getShops(location.lat(), location.lng());
            }
        });

    }

    /**
     * This is specifically to open the the Map in About section of the Shop profile
     * to the full map. The About page also passes an array of objects even though
     * there is just one item
     *
     * @todo decouple this so it passes any single shop object
     */
    private openFullMap(): void {
        let shop = this.shops[0];

        this.navCtrl.push(DiscoveryFeedMapPage, {
            shop: shop,
            latLng: shop.latLng,
            fullScreen: true,
            fromAbout: true
        });
    }

    /**
     *
     * @param event
     * @param shop
     */
    private openPage(event: any, shop: object) {
        this.navCtrl.push(ShopPage, {
            shop: shop
        });
    }

    /**
     *
     * @param lat
     * @param lng
     */
    getShops(lat, lng) {
        this.loading = true;

        this.deleteMarkers();
        this.http.get(`/teams/${lat}/${lng}/10`)
            .subscribe((shops: Array<any>) => {
                this.shops = shops;
                this.getShopQueueTime(this.shops);
                this.loading = false;
            }, error => {
                this.loading = false;
                this.errors = this.apiErrorHandler.handleError(error);
            }, () => {
                // Add the shop markers
                this.addMarkers(this.shops, this.map);
                //
                // Add current location marker
                // this.addCurrentLocationMarker(lat, lng);

                // Publish the shops and center coordinates to dragged event
                let latLng = <latLng>{
                    lat: this.map ? this.map.getCenter().lat() : 0,
                    lng: this.map ? this.map.getCenter().lng() : 0
                };

                this.events.publish('map:idle', latLng, this.shops);
            })
    }

    getShopQueueTime(shops) {

        // Iterate over each shop and make an api request to get the current queue time
        shops.forEach(shop => {
            this.http.get(`/teams/${shop.id}/queue`)
                .subscribe((response: any) => {
                    shop.queue = response;
                });
        });

    }


    /**
     *
     * @param lat
     * @param lng
     */
    addCurrentLocationMarker(lat, lng) {
        let latLng = new google.maps.LatLng(lat, lng);

        // Add the marker for the user's location
        let currentLocationOptions = {
            map: this.map,
            icon: this.createIcon("current-location", 24, 24),
            position: latLng,
            currentLocation: true
        };

        // @ts-ignore
        let currentLocationMarker = new google.maps.Marker(currentLocationOptions);
        currentLocationMarker.setPosition(latLng);

        this.markers.push(currentLocationMarker);
    }

    setMapOnAll(map) {
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(map);
        }
    }

    clearMarkers() {
        this.setMapOnAll(null);
    }

    deleteMarkers() {
        this.clearMarkers();
        this.markers = [];
    }
}



// WEBPACK FOOTER //
// ./src/components/google-maps/google-maps.ts